import React from 'react'
import '../styles/about.css'
export const About = () => {
    return (
        <div className='aboutmain'>
            <div className='abouthead'>
                <h1>About Us</h1>
            </div>
            <div className='aboutpre'>
                <p>
                    Established in 2017 in Madurai, Tamil Nadu,V Packs specializes in the manufacturing, wholesale, and service of industrial packaging machinery. Our offerings include pouch packing machines, strapping machines, sealing machines, conveyors, date printers, coding machines, and custom industrial automation solutions.
                    <br/>
                    We also provide expert services in packaging machinery repair, customized machine manufacturing, PLC programming, industrial electrical work, and packaging material supply. At V Packs, we are committed to delivering innovative and reliable solutions tailored to meet the unique needs of our clients.
                </p>
            </div>
            <br /> <br /> <br />
            <br /> <br /> <br />
            <br /> <br /> <br />

        </div>
    )
} 
